// eslint-disable-next-line import/prefer-default-export
export const PR_REGULAR_PRICE = process.env.REACT_APP_STRIPE_PROFITROVER_REGULAR_PRICE_NICKNAME;
export const PR_COUPON = process.env.REACT_APP_STRIPE_PROFITROVER_COUPON;
